import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appGetAllProject } from '../../store/socialproject'
import { socialProjectExportColumns } from '../../config/exportColumns/socialProjectExportColumns'

function SocialProject() {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Social Project</div>

					<div className="d-flex gap-2">
						<ExportButton
							fetchAction={params =>
								dispatch(
									appGetAllProject({
										...params,
										...exportFilters,
										hub: hubId || permissionOfHub,
										limit: 10000,
										loading: false,
									}),
								)
							}
							columns={socialProjectExportColumns}
							fileName="Social_Projects"
							sheetName="Social Project List"
							buttonText="Export Social Projects"
						/>

						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/social-project/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Social Project
						</button>
					</div>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default SocialProject
